<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <section>
          <v-row
            class="pa-5 pb-0">
            <v-col
              cols="12">
              <v-card
                to="/shift-kasir"
                flat
                color="transparent"
                style="width: 20%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Detail Shift Kasir
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-5">
            <v-col 
              cols="12"
              class="py-0">
              <v-card v-if="process.load && Object.keys(detail).length < 1"
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>
              </v-card>

              <div v-if="!process.load && Object.keys(detail).length > 0">
                <v-row>
                  <v-col cols="12" md="3">
                    <v-card flat style="background: #E8F5E9; border-radius: 10px;">
                      <v-card-text>
                        <div>
                          Kas Masuk
                        </div>
                        <div class="title black_one font_weight_600">
                          {{ detail.kas_masuk | price }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-card flat style="background: #E8EAF6; border-radius: 10px;">
                      <v-card-text>
                        <div>
                          Penjualan
                        </div>
                        <div class="title black_one font_weight_600">
                          {{ detail.total_penjualan | price }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-card flat style="background: #FFEBEE; border-radius: 10px;">
                      <v-card-text>
                        <div>
                          Kas Keluar
                        </div>
                        <div class="title black_one font_weight_600">
                          {{ detail.kas_keluar | price }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-card flat style="background: #F5F5F5; border-radius: 10px;">
                      <v-card-text>
                        <div>
                          Jumlah Setor
                        </div>
                        <div class="title black_one font_weight_600">
                          {{ detail.total_setoran | price }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-card 
                      flat
                      class="mt-5"
                      style="border-radius: 10px; border: 1px solid #E7E7E7;">
                      <v-card-text>
                        <div class="fs-16">
                          Informasi Shift Kasir
                        </div>
                        <v-divider
                          class="mt-2 mb-4">
                        </v-divider>
                        <div class="d-flex">
                          <div style="width: 50%">
                            <div class="mb-3">
                              <div class="fs-12">
                                Nama Pegawai
                              </div>
                              <div class="fs-16 black_one font_weight_600">
                                {{ detail.admin_name }}
                              </div>
                            </div>
                            <div class="mb-3">
                              <div class="fs-12">
                                Tanggal Buka Shift
                              </div>
                              <div class="fs-16 black_one font_weight_600">
                                {{ detail.open_datetime | datetime }}
                              </div>
                            </div>
                          </div>

                          <div style="width: 50%">
                            <div class="mb-3">
                              <div class="fs-12">
                                Nama Penerima
                              </div>
                              <div class="fs-16 black_one font_weight_600">
                                {{ detail.petugas_penerima_name == '' ? '-' : detail.petugas_penerima_name }}
                              </div>
                            </div>
                            <div class="mb-3">
                              <div class="fs-12">
                                Tanggal Tutup Shift
                              </div>
                              <div class="fs-16 black_one font_weight_600">
                                <span v-if="detail.close_datetime === '' || detail.close_datetime === null">
                                  -
                                </span>
                                <span v-else>
                                  {{ detail.close_datetime | datetime }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>

                    <v-row>
                      <v-col cols="12" md="6">
                        <v-card 
                          flat
                          class="mt-5"
                          style="border-radius: 10px; border: 1px solid #E7E7E7;">
                          <v-card-text>
                            <div class="fs-16">
                              Total Penjualan
                            </div>
                            <v-divider
                              class="mt-2 mb-4">
                            </v-divider>
                            <table class="" style="width: 100%;">
                              <tr>
                                <td class="py-2">
                                  Tunai
                                </td>
                                <td class="fs-14 font_weight_600 text-right py-2">
                                  {{ detail.sales_cash | price }}
                                </td>
                              </tr>
                              <tr>
                                <td class="py-2">
                                  Transfer
                                </td>
                                <td class="fs-14 font_weight_600 text-right py-2">
                                  {{ detail.sales_transfer | price }}
                                </td>
                              </tr>
                              <tr>
                                <td class="py-2">
                                  E-Wallet
                                </td>
                                <td class="fs-14 font_weight_600 text-right py-2">
                                  {{ detail.sales_ewallet | price }}
                                </td>
                              </tr>
                              <tr>
                                <td class="py-2">
                                  QRIS
                                </td>
                                <td class="fs-14 font_weight_600 text-right py-2">
                                  {{ detail.sales_qris | price }}
                                </td>
                              </tr>
                            </table>
                          </v-card-text>
                        </v-card>
                      </v-col>  
                      <v-col cols="12" md="6">
                        <v-card 
                          flat
                          class="mt-5"
                          style="border-radius: 10px; border: 1px solid #E7E7E7;">
                          <v-card-text>
                            <div class="fs-16">
                              Tansaksi
                            </div>
                            <v-divider
                              class="mt-2 mb-4">
                            </v-divider>
                            <table class="" style="width: 100%;">
                              <tr>
                                <td class="py-2">
                                  Total Transaksi
                                </td>
                                <td class="fs-14 font_weight_600 text-right py-2">
                                  {{ detail.transaction_qty }}
                                </td>
                              </tr>
                              <tr>
                                <td style="color: #1A237E;" class="py-2">
                                  Transaksi Selesai
                                </td>
                                <td style="color: #1A237E;" class="fs-14 font_weight_600 text-right py-2">
                                  {{ detail.transaction_done_qty }}
                                </td>
                              </tr>
                              <tr>
                                <td style="color: #E65100;" class="py-2">
                                  Transaksi Berlangsung
                                </td>
                                <td style="color: #E65100;" class="fs-14 font_weight_600 text-right py-2">
                                  {{ detail.transaction_pending_qty }}
                                </td>
                              </tr>
                              <tr>
                                <td style="color: #B71C1C;" class="py-2">
                                  Transaksi Dibatalkan
                                </td>
                                <td style="color: #B71C1C;" class="fs-14 font_weight_600 text-right py-2">
                                  {{ detail.transaction_cancel_qty }}
                                </td>
                              </tr>
                            </table>
                          </v-card-text>
                        </v-card>
                      </v-col>  
                    </v-row>
                  </v-col>  
                  <v-col cols="12" md="6">
                    <v-card 
                      flat
                      class="mt-5"
                      style="border-radius: 10px; border: 1px solid #E7E7E7;">
                      <v-card-text class="pb-0">
                        <div class="fs-16">
                          Riwayat Transaksi
                        </div>
                        <v-divider
                          class="mt-2 mb-4">
                        </v-divider>
                      </v-card-text>
                      <v-card-text style="height: 403px; overflow: auto;" class="pt-0">
                        <div>
                          <v-card flat style="border-radius: 10px; border: 1px solid #E7E7E7;" v-for="(item, index) in detail.data_so" :key="index" class="mb-4">
                            <v-card-text>
                              <div class="fs-16 font_weight_600" style="color: #1A237E;">
                                <v-icon class="mr-3" color="#1A237E">mdi-calendar-blank</v-icon>
                                {{ item.so_input_datetime | datetime }}
                              </div>
                              <v-divider
                                class="mt-2 mb-4">
                              </v-divider>
                              <v-row>
                                <v-col cols="12" md="6" class="pt-0">
                                  <div class="fs-14 mb-1">
                                    No. Pesanan
                                  </div>
                                  <div class="fs-16 font_weight_600 black_one">
                                    {{ item.so_number }}
                                  </div>
                                </v-col>
                                <v-col cols="12" md="6" class="pt-0">
                                  <div class="fs-14 mb-1">
                                    No. Transaksi
                                  </div>
                                  <div class="fs-16 font_weight_600 black_one">
                                    {{ item.so_trans_number === '' ? '-' : item.so_trans_number }}
                                  </div>
                                </v-col>

                                <v-col cols="12" md="6" class="pt-0">
                                  <div class="fs-14 mb-1">
                                    Pelanggan
                                  </div>
                                  <div class="fs-16 font_weight_600 black_one">
                                    {{ item.so_customer_name }}
                                  </div>
                                </v-col>
                                <v-col cols="12" md="6" class="pt-0">
                                  <div class="fs-14 mb-1">
                                    Pembayaran
                                  </div>
                                  <div class="fs-16 font_weight_600 black_one text-capitalize">
                                    {{ item.so_payment_method === '' || item.so_payment_method === null ? '-' : item.so_payment_method }}
                                  </div>
                                </v-col>

                                <v-col cols="12" md="6" class="pt-0">
                                  <div class="fs-14 mb-1">
                                    <span v-if="item.so_payment_method !== null">
                                      <span v-if="item.so_payment_method !== 'tunai'">Jenis</span>
                                      <span v-else>Total Tagihan</span>
                                    </span>
                                    <span v-if="item.so_payment_method === null">
                                      Jenis
                                    </span>
                                  </div>
                                  <div class="fs-16 font_weight_600 black_one">
                                    <span v-if="item.so_payment_method !== null">
                                      <span v-if="item.so_payment_method !== 'tunai'">
                                        {{ item.so_sub_total | price }}
                                      </span>
                                      <span v-else>
                                        {{ item.so_sub_total | price }}
                                      </span>
                                    </span>
                                    <span v-if="item.so_payment_method === null">
                                      -
                                    </span>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="6" class="pt-0">
                                  <div class="fs-14 mb-1">
                                    Total Bayar
                                  </div>
                                  <div class="fs-16 font_weight_600 black_one">
                                    <span v-if="item.so_total === ''">
                                      -
                                    </span>
                                    <span v-else>
                                      {{ item.so_total | price }}
                                    </span>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>


              <v-card v-if="!process.load && Object.keys(detail).length > 0"
                class="mt-5"
                flat>
                <v-card-actions
                  class="px-0">
                  <v-spacer/>

                  <v-btn
                    :disabled="process.form || process.export"
                    :loading="process.export"
                    color="#1A237E"
                    @click="exports()"
                    elevation="0"
                    width="120"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4"
                    style="border-radius: 10px; font-weight: 600;">
                    <v-icon size="20">mdi-file-export</v-icon>

                    <span
                      class="ml-2">
                      Export
                    </span>
                  </v-btn>
                  
                  <v-btn
                    to="/shift-kasir"
                    :disabled="process.form || process.export"
                    color="red"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4"
                    style="border-radius: 10px; font-weight: 600;">
                    <v-icon 
                      size="20">
                      mdi-progress-close
                    </v-icon>

                    <span
                      class="ml-2">
                      Kembali
                    </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          snackbar: false,

          role: false
        },
        
        detail: {},

        role: [],

        list: [],

        form: {
          id: '',
          role_id: ''
        },
        
        process: {
          load: false,

          role: false,
          export: false,
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      company () {
        return this.$store.state.company
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    beforeMount () {
      this.fetchDetail()
    },
    mounted () {
      
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get(`pos/shift_kasir/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.detail = res.results.data
          }
        })
      },
      async exports () {
        this.message.error = ''

        this.process.export = true

        let params = {
          id: this.$route.params.id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}/pos/shift_kasir/export_pdf`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response
          // console.log(res)

          this.process.export = false
          let disposition = res.headers['content-disposition']
          var fileName = res.headers['content-disposition'].split('filename=')[1]
          let filename = ''
          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      },
    }
  }
</script>